import View from './view';

export default View.extend( {

    events: {
        'click .-section--choose': function(e) {
            const {sectionId} = e.currentTarget.dataset;
            const [sectionToChoose] = this.options.items
                .filter( section => section.id == sectionId );

            this.trigger( 'section:choose', sectionToChoose );
        },

        'click .-section--add-start'() {
            this.trigger( 'section:add-start' );
        },

        'click .-section--edit-start'(e) {
            e.stopPropagation();
            
            const {sectionId} = e.currentTarget.dataset;
            const [sectionToEdit] = this.options.items
                .filter( section => section.id == sectionId );

            this.trigger( 'section:edit-start', sectionToEdit );
        },

        'click .-section--remove': function(e) {
            e.stopPropagation();

            const {sectionId} = e.currentTarget.dataset;
            this.trigger( 'section:remove', sectionId );
        },
    },

    serialize() {
        return {
            items: this.options.items,
            activeSection: this.options.activeSection,
        }
    },
} );


// WEBPACK FOOTER //
// ./src/js/view/config.sections.js